module.exports = __webpack_public_path__ + "img/correct2.d4384289.jpg";